var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trip-map"},[_c('mapbox',{ref:"map",on:{"load":_vm.onLoad}},[_c('div',{ref:"markerStart",staticClass:"marker"}),_c('div',{ref:"markerEnd",staticClass:"marker"}),_c('div',{ref:"markerCurrent",staticClass:"marker"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }